<template>
  <div class="col page">
    <div class="form" ref="formContainer">
      <user-contact
        :topOrBottom="'top'"
        :currentTopOrBottom="topOrBottom"
        :contact="newContact"
        :existing="false"
        :allData="allData"
        :someoneEditing="someoneEditing"
        :emptyContact="emptyContact"
        v-on:begin-edit="handleBeginEdit"
        v-on:cancel-edit="handleCancelEdit"
        :allContacts="contacts"
        v-on:delete-contact="handleDelete"
        v-on:load-model="handleLoadModel"
        v-on:contact-saved="handleSaved"
      />
      <user-contact
        v-for="contact in contacts"
        :key="contact.id"
        :contact="contact"
        :existing="true"
        :allData="allData"
        :someoneEditing="someoneEditing"
        :emptyContact="emptyContact"
        v-on:begin-edit="handleBeginEdit"
        :allContacts="contacts"
        v-on:cancel-edit="handleCancelEdit"
        v-on:delete-contact="handleDelete"
        v-on:load-model="handleLoadModel"
        v-on:contact-saved="handleSaved"
        :topOrBottom="'neither'"
        :currentTopOrBottom="topOrBottom"
      />
      <user-contact
        :topOrBottom="'bottom'"
        :contact="newContact"
        :existing="false"
        :allData="allData"
        :someoneEditing="someoneEditing"
        :emptyContact="emptyContact"
        v-on:begin-edit="handleBeginEdit"
        v-on:cancel-edit="handleCancelEdit"
        :allContacts="contacts"
        v-on:delete-contact="handleDelete"
        v-on:load-model="handleLoadModel"
        v-on:contact-saved="handleSaved"
        :currentTopOrBottom="topOrBottom"
      />
    </div>
  </div>
</template>

<script>
import { getPrimaryContact } from "@/data/getters";
import UserContact from "./UserContact.vue";
import { uuid } from "vue-uuid";
import {
  updateLicenseStatus,
  getLicenses,
  getContacts,
  createContact,
  updateContact,
  deleteContact,
  renameContact,
  setPrimaryContact,
} from "@/api/userApi";
import axios from "axios";
import { Collapse } from "bootstrap";

export default {
  name: "user-contacts",
  props: {
    restricted: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "user-contact": UserContact,
  },
  data() {
    return {
      allData: this.$store.getters["login/getAllData"],
      contacts: [],
      newContact: this.createEmptyContact(),
      emptyContact: this.createEmptyContact(),
      someoneEditing: false,
      topOrBottom: "neither",
    };
  },
  computed: {},
  created() {
    this.loadModel();
  },
  methods: {
    handleSaved() {
      this.someoneEditing = false;
      this.newContact = this.createEmptyContact();
      this.loadModel();
    },
    handleBeginEdit(params) {
      this.topOrBottom = params.topOrBottom;
      this.someoneEditing = true;
    },
    handleCancelEdit() {
      this.someoneEditing = false;
    },
    /*
    handleSave({contact,existing}) {
      if(existing)
        updateContact(contact).then((response)=>{
          if(response.length) {
            let msgs = [...new Set(Object.values(response))];
            alert(msgs.join("\m"));
          }
          else {
            this.loadModel();
          }
        })
      else
        createContact(contact).then((response)=>{
          if(response.length) {
            
          }
          this.loadModel)
    },*/
    handleDelete({ contact }) {
      if (confirm("Are you sure you would like to delete this contact?")) {
        deleteContact({ id: contact.id }).then(this.loadModel);
        this.someoneEditing = false;
      }
    },
    handleLoadModel() {
      this.loadModel();
    },
    loadModel() {
      getContacts().then((contacts) => {
        const emptyContact = this.createEmptyContact();
        for (let contactIndex = 0; contactIndex < contacts.length; contactIndex++) {
          for (let fieldName in emptyContact) {
            if (contacts[contactIndex][fieldName] === undefined)
              contacts[contactIndex][fieldName] = emptyContact[fieldName];
          }
        }
        this.contacts = contacts;
        this.primaryContact = getPrimaryContact(contacts);
      });
    },
    licenseStatusClass(contact) {
      switch (contact.status) {
        case "UNENCUMBERED":
          return "text-success";
        case "EXPIRED":
        case "ENCUMBERED":
          return "text-danger";
      }
      return "text-dark";
    },
    createEmptyContact() {
      return JSON.parse(
        JSON.stringify({
          id: "",
          firstName: "",
          lastName: "",
          relationType: 0,
          primaryPhone: "",
          primaryPhoneType: 0,
          secondaryPhone: "",
          secondaryPhoneType: 0,
          email: "",
          address1: "",
          address2: "",
          city: "",
          state: 0,
          zip: "",
          ssn: "",
          dob: "",
          license: "",
          licenseState: 0,
          licenseId: 0,
        })
      );
    },
    async webHook(request) {
      return await axios.post(CURR_API + "/tswebhook.php", request, {
        headers: { "Content-Type": "application/json;" },
      });
    },
    async startLookup(request) {
      return this.webHook({
        NursysInfo: {
          API_Meth: "LookupNursesInfo",
          ncsid: "",
          ltype: "RN",
          ...request,
        },
      });
    },
    async startAdd(request) {
      return this.webHook({
        API_Meth: "Add_Nurse",
        ncsid: "",
        subactioncode: "A",
        ltype: "RN",
        address1: "Manhattan",
        address2: "",
        city: "New York",
        state: "NY",
        zip: "10001",
        hospitalpracsetting: "8",
        hostpracsettingother: "",
        notficationenabled: "N",
        reminderenabled: "N",
        locationlist: "",
        recid: "",
        ...request,
      });
    },
    isRelated(contact, items) {
      if (contact && contact.relationType && items) {
        let f = this.relation.find((r) => r.id === contact.relationType);
        return f && items.includes(f.value);
      }
      return false;
    },
    isLicensed(contact) {
      return this.isRelated(contact, [
        "Licensed Practical Nurse",
        "Registered Nurse",
        "Geriatric Care Manager",
        "Physical Therapist",
        "Occupational Therapist",
        "Dietician",
        "Social Worker",
        "Speech Therapist",
      ]);
    },
    queryLicense(ind) {
      getLicenses({
        license: contact.license,
        state: contact.licenseState,
        firstName: contact.firstName,
        lastName: contact.lastName,
      })
        .then((resp) => {
          if (!resp || resp.length == 0 || resp[0].length == 0)
            !alert("No licensed individual with the inputted id and state");
          else {
            !alert("Available licensed individual information loaded");
            contact.firstName = resp.fst || "";
            contact.lastName = resp.lst || "";
            contact.primaryPhone = resp.phone1 || "";
            contact.secondaryPhone = resp.phone2 || "";
            contact.city = resp.city || "";
            contact.address1 = resp.address1 || "";
            contact.contactEmail = resp.email || "";
            contact.address2 = resp.addr2 || "";
            contact.zip = resp.zip || "";
            contact.state = resp.state || 0;
            contact.primaryPhoneType = resp.phone1type || 0;
            contact.secondaryPhoneType = resp.phone2type || 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClearPriority({ contact }) {
      setPrimaryContact({ id: contact.id, primaryContact: false })
        .then((a) => {
          if (a.length == 0) {
            this.handleLoadModel();
          } else {
            let msgs = [...new Set(Object.values(a))];
            let alertMsg = "";
            for (var m of msgs) {
              alertMsg = alertMsg + m + "\n";
            }
            alert(alertMsg);
          }
        })
        .catch((b) => {
          alert("Error: Please contact website administration");
          console.dir(b);
        });
    },
    handleSetPriority({ contact }) {
      setPrimaryContact({ id: contact.id, primaryContact: true }).then((a) => {
        if (a.length == 0) {
          this.handleLoadModel();
        } else {
          let msgs = [...new Set(Object.values(a))];
          let alertMsg = "";
          for (var m of msgs) {
            alertMsg = alertMsg + m + "\n";
          }
          alert(alertMsg);
        }
      });
    },
    cancelAdd() {
      if (!this.justLooking(this.newContact)) throw "Canceling bad add";
      this.$set(contact, "original");
    },
    handleNewSubmit() {
      createContact(this.newContact)
        .then((a) => {
          console.log(a);
          if (
            a.length == 0 ||
            a.hasOwnProperty("id") ||
            a.hasOwnProperty("newId") ||
            a.hasOwnProperty("newlicenseid")
          ) {
            if (this.newStatus) {
              updateLicenseStatus({
                state: this.states.find(
                  (state) => state.name == formData.get("licenseState")
                ).id,
                license: formData.get("licenseNumber"),
                status: this.newStatus,
              }).then((b) => {
                if (!alert("New contact added.")) {
                  this.newQuery = false;
                  window.location.reload();
                }
              });
            } else {
              if (!alert("New contact added.")) {
                this.newQuery = false;
                window.location.reload();
              }
            }
          } else {
            let msgs = [...new Set(Object.values(a))];
            let alertMsg = "";
            for (var m of msgs) {
              alertMsg = alertMsg + m + "\n";
            }
            alert(alertMsg);
          }
        })
        .catch((b) => {
          alert("Error: Please contact website administration");
          console.dir(b);
        });
    },
    handleContactEdit(contact) {
      this.$set(contact, "original", JSON.stringify(contact));
    },
    handleContactCancel(contact) {
      this.$delete(contact, "original");
    },
    buttonClass(contact, name) {
      // switch(name) {
      //   case 'verify':
      //     return contact.licenseState && contact.license ? '' : 'd-none';
      //   case 'save':
      //     this.createEmptyContact
      // }
      // if(contact.isNew) {
      //   switch(name) {
      //     case 'save':
      //     case 'cancel':
      //     case 'edit':
      //     case 'query':
      //       this.isEditing() && !this.justLooking(contact) ||
      //     case 'verify':
      //       return contact.licenseState && contact.license ? '' : 'd-none';
      //   }
      // }
      // else {
      //   switch(name) {
      //     // case 'query':
      //     // case 'verify':
      //     case 'edit':
      //       return contact.original ? 'd-none' : '';
      //     case 'cancel':
      //     case 'submit':
      //       return contact.original ? '' : 'd-none';
      //     case 'delete':
      //       return this.isImmutable(contact)  ? 'd-none' : ''
      //   }
      // }
      // throw 'Bad button class';
    },
    handleSubmit(_contact) {
      let contact = {};
      for (const key in this.createEmptyContact) {
        contact[key] = _contact[key];
      }
      (contact.isNew ? createContact(contact) : updateContact(contact))
        .then((a) => {
          if (contact.isNew) {
            if (
              a.length === 0 ||
              a.hasOwnProperty("id") ||
              a.hasOwnProperty("newId") ||
              a.hasOwnProperty("newlicenseid")
            ) {
              if (contact.status) {
                updateLicenseStatus({
                  state: contact.licenseState,
                  license: contact.license,
                  status: contact.status,
                });
              }
            }
          }
          if (a.length == 0) {
            if (!alert("Contact updated.")) {
              window.location.reload();
            }
          } else {
            let msgs = [...new Set(Object.values(a))];
            let alertMsg = "";
            for (var m of msgs) {
              alertMsg = alertMsg + m + "\n";
            }
            alert(alertMsg);
          }
        })
        .catch((b) => {
          alert("Error: Please contact website administration");
          console.dir(b);
        });
    },
  },
};
</script>

<style scoped lang="scss">
$color-base: #0060ff;

.page {
  background-color: #fff;
  margin: 1.5rem auto;
  padding: 2rem;
  margin-bottom: 100px;
}

.profile__header {
  font-size: 1.5rem;
  color: $color-base;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}

.profile__label {
  font-size: 0.8rem;
  color: $color-base;
}

.profile__checkbox {
  font-size: 0.8rem;
  color: lighten(#000, 30%);
}

input,
select {
  font-size: 0.8rem;
}

.btn-container {
  margin-top: 1rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

.new-cancel {
  background-color: red;
  border-color: red;
}

.cancel {
  visibility: hidden;
  background-color: red;
  border-color: red;
}

.submit {
  visibility: hidden;
}

.delete {
  visibility: hidden;
}

.favorite {
  color: red;
}

.unfavorite {
  color: $color-base;
}

.licenseInfo {
  display: flex;
  justify-content: center;
}

.statusInfo {
  color: $color-base;
  justify-content: center;
}

.button-container {
  display: flex;
  align-items: flex-end;
}

button[name="query_btn"]:enabled {
  background-color: $color-base;
  color: white;
}

button[name="validate_btn"]:enabled {
  background-color: $color-base;
  color: white;
}
</style>
